export const AP_D3_SEARCH_LOADER = {
  desktop: `<div class="cui cui-grid cui-container">
      <div class="cui-row -spacing--top-64 -spacing--bottom-120">
        <div class="cui-col -spacing--right-40" style="max-width: 18rem">
          <div class="cui-skeleton-paragraph">
            <div class="cui-skeleton-paragraph__content" style="width: 100%">
              <div class="cui-skeleton__item cui-skeleton__description" style="width: 140px; height: 1rem"></div>
              <div class="cui-skeleton__item cui-skeleton__description" style="height: 1rem"></div>
              <div class="cui-skeleton__item cui-skeleton__description" style="height: 1rem"></div>
              <div class="cui-skeleton__item cui-skeleton__description" style="height: 1rem"></div>
              <div class="cui-skeleton__item cui-skeleton__description" style="height: 1rem"></div>
            </div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--top-32">
            <div class="cui-skeleton__item" style="width: 100%; height: 240px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--top-32">
            <div class="cui-skeleton__item" style="width: 100%; height: 128px"></div>
          </div>
        </div>
        <div class="cui-col" style="min-width: min(30rem,100%)">
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-16">
            <div class="cui-skeleton__item" style="height: 40px; width: min(300px, 100%)"></div>
          </div>
          <div class="cui-skeleton-paragraph -spacing--top-16 -spacing--bottom-40">
            <div class="cui-skeleton-paragraph__content" style="width: min(730px, 100%)">
              <div class="cui-skeleton__item" style="height: 16px"></div>
            </div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-40">
            <div class="cui-skeleton__item" style="height: 48px; width: min(540px, 100%)"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-40">
            <div class="cui-skeleton__item" style="height: 48px; width: min(540px, 100%)"></div>
          </div>
          <div class="cui-skeleton-paragraph -spacing--top-16 -spacing--bottom-24">
            <div class="cui-skeleton-paragraph__content" style="width: 100%">
              <div class="cui-skeleton__item cui-skeleton__description" style="width: 200px; height: 27px"></div>
            </div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-48">
            <div class="cui-skeleton__item" style="width: 100%; height: 98px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-48">
            <div class="cui-skeleton__item" style="width: 100%; height: 98px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-48">
            <div class="cui-skeleton__item" style="width: 100%; height: 98px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-48">
            <div class="cui-skeleton__item" style="width: 100%; height: 98px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-48">
            <div class="cui-skeleton__item" style="width: 100%; height: 98px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-48">
            <div class="cui-skeleton__item" style="width: 100%; height: 98px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-48">
            <div class="cui-skeleton__item" style="width: 100%; height: 98px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-48">
            <div class="cui-skeleton__item" style="width: 100%; height: 98px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--bottom-48">
            <div class="cui-skeleton__item" style="width: 100%; height: 98px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block">
            <div class="cui-skeleton__item" style="width: 100%; height: 98px"></div>
          </div>
          <div class="cui-skeleton-rectangle -is--block -spacing--top-48">
            <div class="cui-skeleton__item" style="width: 100%; height: 32px"></div>
          </div>
        </div>
      </div>
    </div>`
};
